/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskIndicatorTypeShallow
 */
export interface RiskIndicatorTypeShallow {
  /**
   *
   * @type {number}
   * @memberof RiskIndicatorTypeShallow
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RiskIndicatorTypeShallow
   */
  name: string;
}

/**
 * Check if a given object implements the RiskIndicatorTypeShallow interface.
 */
export function instanceOfRiskIndicatorTypeShallow(value: object): value is RiskIndicatorTypeShallow {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function RiskIndicatorTypeShallowFromJSON(json: any): RiskIndicatorTypeShallow {
  return RiskIndicatorTypeShallowFromJSONTyped(json, false);
}

export function RiskIndicatorTypeShallowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskIndicatorTypeShallow {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function RiskIndicatorTypeShallowToJSON(value?: Omit<RiskIndicatorTypeShallow, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
